function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.5 3.5L5 7l3.5-3.5",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "bevel"
});

const SvgChevronDown = props => React.createElement("svg", _extends({
  viewBox: "0 0 10 9",
  fill: "none"
}, props), _ref);

export default SvgChevronDown;